import { API } from "../api";

export const money = (n, cur = "mxn") =>
  new Intl.NumberFormat("es-MX", { style: "currency", currency: cur.toUpperCase() }).format(Number(n) || 0);

const errText = (d) => {
  if (!d) return "Ocurrió un error. Intenta de nuevo.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || "").filter(Boolean).join(" ") || "Datos inválidos";
  return d.msg || "Ocurrió un error";
};

export const mk = async (path, { method = "GET", body, token } = {}) => {
  const res = await fetch(`${API}/market${path}`, {
    method,
    headers: { ...(body ? { "Content-Type": "application/json" } : {}), ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const e = new Error(errText(data.detail));
    e.status = res.status;
    throw e;
  }
  return data;
};

export const ORDER_LABELS = {
  pending_payment: "Pendiente de pago",
  paid: "Pagado",
  preparing: "Preparando",
  shipped: "Enviado",
  ready: "Listo para recoger",
  delivered: "Entregado",
  cancelled: "Cancelado",
};

export const FONTS = ["Poppins", "Montserrat", "DM Sans", "Playfair Display", "Outfit", "Space Grotesk"];

export const loadFont = (f) => {
  if (!f) return;
  const id = `gf-${f.replace(/\s/g, "-")}`;
  if (document.getElementById(id)) return;
  const l = document.createElement("link");
  l.id = id;
  l.rel = "stylesheet";
  l.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(f)}:wght@400;500;600;700;800&display=swap`;
  document.head.appendChild(l);
};

const onColor = (hex = "#2563EB") => {
  const h = hex.replace("#", "");
  const n = parseInt(h.length === 3 ? h.split("").map((c) => c + c).join("") : h, 16);
  const [r, g, b] = [(n >> 16) & 255, (n >> 8) & 255, n & 255];
  return (0.299 * r + 0.587 * g + 0.114 * b) / 255 > 0.62 ? "#0F172A" : "#FFFFFF";
};

export const themeVars = (t = {}) => ({
  "--mk-primary": t.primary || "#2563EB",
  "--mk-on-primary": onColor(t.primary),
  "--mk-accent": t.accent || "#F59E0B",
  "--mk-bg": t.bg || "#F5F7FB",
  "--mk-surface": t.surface || "#FFFFFF",
  "--mk-text": t.text || "#0F172A",
  "--mk-radius": `${t.radius ?? 18}px`,
  fontFamily: `'${t.font || "Poppins"}', system-ui, sans-serif`,
});
